export const videoModal = () => {
  const modal = document.querySelector(".js-video-modal");
  const openBtn = document.querySelector(".js-video-modal-open");
  const closeBtn = document.querySelector(".js-video-modal-close");

  openBtn.addEventListener("click", () => {
    modal.classList.add("is-active");
  });

  closeBtn.addEventListener("click", () => {
    modal.classList.remove("is-active");
  });
};
